"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isClassComponent = isClassComponent;
function isClassComponent(Component) {
    var _a, _b;
    return typeof ((_a = Component.prototype) === null || _a === void 0 ? void 0 : _a.render) === 'function' && ((_b = Component === null || Component === void 0 ? void 0 : Component.prototype) === null || _b === void 0 ? void 0 : _b.isReactComponent);
}
//# sourceMappingURL=reactNode.js.map